import sanityClient from '@sanity/client'

export const client = sanityClient({
    projectId: 'g5c9f8kd',
    dataset: 'production'
})